import { render, staticRenderFns } from "./HorizontalMasonry.vue?vue&type=template&id=ed6b224a&scoped=true&"
import script from "./HorizontalMasonry.vue?vue&type=script&lang=js&"
export * from "./HorizontalMasonry.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalMasonry.vue?vue&type=style&index=0&id=ed6b224a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6b224a",
  null
  
)

export default component.exports